var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49 13.811c1.944 1.914 4.907 4.628 7.677 4.646 2.603.018 4.333-2.016 4.333-2.016l-3.69-3.69-2.97 1.088L6.49 8.49l1.123-2.935L4.06 2S2.032 3.737 2 6.292c-.033 2.717 2.647 5.646 4.49 7.519z",
    stroke: "#90939E",
    strokeWidth: 1.01
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik02LjQ4OTMgMTMuODExQzguNDM0MyAxNS43MjUgMTEuMzk3MyAxOC40MzkgMTQuMTY3MyAxOC40NTdDMTYuNzcwMyAxOC40NzUgMTguNTAwMyAxNi40NDEgMTguNTAwMyAxNi40NDFMMTQuODA5MyAxMi43NTFMMTEuODM5MyAxMy44MzlMNi40ODkzIDguNDlMNy42MTMzIDUuNTU1TDQuMDYwMyAyQzQuMDYwMyAyIDIuMDMyMyAzLjczNyAyLjAwMDMgNi4yOTJDMS45NjczIDkuMDA5IDQuNjQ3MyAxMS45MzggNi40ODkzIDEzLjgxMVoiIHN0cm9rZT0iIzkwOTM5RSIgc3Ryb2tlLXdpZHRoPSIxLjAxIi8+Cjwvc3ZnPgo=";
export { SvgPhoneIcon as ReactComponent };